export default __webpack_public_path__ + "static/media/addnewIcon.0ffc7b86.svg";